import React from "react";
import moment from "moment/moment";

const TYPE_META = {
  trial_grant: { label: "Trial", color: "#16a34a", positive: true },
  admin_grant: { label: "Admin Grant", color: "#8b5cf6", positive: true },
  topup_purchase: { label: "Top-up", color: "#16a34a", positive: true },
  topup_consume: { label: "Consumed", color: "#dc2626", positive: false },
  subscription_consume: { label: "Consumed", color: "#dc2626", positive: false },
  subscription_reset: { label: "Renewed", color: "#2563eb", positive: true },
  refund: { label: "Refund", color: "#16a34a", positive: true },
};

const formatAmount = (row) => {
  const meta = TYPE_META[row.type];
  const sign = meta?.positive ? "+" : "-";
  return `${sign}${Math.abs(row.amount)}`;
};

const TransactionTable = ({ rows = [], loading = false, empty = "No transactions yet" }) => {
  if (loading) {
    return (
      <div className="text-muted text-center py-4" style={{ fontSize: 13 }}>
        Loading...
      </div>
    );
  }
  if (!rows.length) {
    return (
      <div className="text-muted text-center py-4" style={{ fontSize: 13 }}>
        {empty}
      </div>
    );
  }

  return (
    <div className="billing-txn-table-wrap">
      <table className="billing-txn-table">
        <thead>
          <tr>
            <th>Date</th>
            <th>Type</th>
            <th>Description</th>
            <th className="text-end">Change</th>
            <th className="text-end">Balance</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => {
            const meta = TYPE_META[row.type] || { label: row.type, color: "#6c757d" };
            return (
              <tr key={row.id}>
                <td>{row.createdAt ? moment(row.createdAt).format("MMM D, YYYY") : "-"}</td>
                <td>
                  <span
                    className="billing-txn-badge"
                    style={{ background: `${meta.color}1a`, color: meta.color }}
                  >
                    {meta.label}
                  </span>
                </td>
                <td className="text-muted" style={{ maxWidth: 300 }}>
                  {row.description || "-"}
                </td>
                <td className="text-end fw-semibold" style={{ color: meta.color }}>
                  {formatAmount(row)}
                </td>
                <td className="text-end">{row.balanceAfter ?? "-"}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default TransactionTable;
